<div class="py-2" *ngIf="styleType == 1">
  <div class="task-container-inner pl-2" [class.isCarryOver]="isCarryOver">
    <div class="flex pb-2 pl-1 pt-1 gap-1 flex-wrap-reverse">
      <div class="flex-grow-1">
        <div class="font-bold" style="font-size: 16px">
          {{ location.addressDisplaySingleLine }}
        </div>
      </div>
      <div class="flex-grow-1 style2023 text-right">
        <div *ngIf="isCarryOver">
          <div class="carryOverText"><i class="fa fa-moon-o"></i> Carryover</div>
        </div>
      </div>
    </div>
    <div *ngIf="!isCarryOver" class="pb-2 pl-1 date-and-time">
      <span class="mr-2" *ngIf="dateString.length > 0">
        <i class="fa fa-calendar"></i>
        {{ dateString }}
      </span>
    </div>

    <div *ngIf="isCarryOver" class="pb-2 pl-1 date-and-time">
      <span class="mr-2">
        <span class="mr-2 opacity-70">Arrive: </span>
        <i class="fa fa-calendar"></i>
        {{ formatDateString(arriveHomeEarliest, arriveHomeLatest) }}
      </span>
    </div>
    <div *ngIf="isCarryOver" class="pb-2 pl-1 date-and-time">
      <span class="mr-2">
        <span class="mr-2 opacity-70">Leave: </span>
        <i class="fa fa-calendar"></i>
        {{ formatDateString(leaveHomeEarliest, leaveHomeLatest) }}
      </span>
    </div>

    <div *ngIf="showTaskBadges">
      <span class="tag">{{ task.taskTypeName }}</span>
      <span class="tag" title="{{ task.vehicle?.make }} {{ task.vehicle?.model }}"
        ><i class="la la-car-side"></i> {{ task.vehicle?.make }} {{ task.vehicle?.model }}</span
      >
      <span *ngIf="task.vehicle.isElectric" class="tag bolt"><i class="fa fa-bolt"></i> EV</span>
    </div>
  </div>
</div>

<div class="py-1" *ngIf="styleType == 2">
  <div class="task-container-inner no-border" [class.isCarryOver]="isCarryOver">
    <div class="flex pb-1 pl-1 pt-1 gap-1 flex-wrap-reverse">
      <div class="flex-grow-1">
        <div class="font-bold" style="font-size: 16px">
          {{ location.addressDisplaySingleLine }}
        </div>
      </div>
      <div class="style2023 text-right">
        <div *ngIf="isCarryOver">
          <div class="carryOverText"><i class="fa fa-moon-o"></i> Carryover</div>
        </div>
      </div>
    </div>
    <div class="pb-1 pl-1 date-and-time-2">
      <span
        class="mr-2"
        *ngIf="dateString.length > 0"
        [pTooltip]="'Schedule: ' + scheduledDateString"
      >
        <i class="fa fa-calendar"></i>
        {{ dateString }}
      </span>
    </div>

    <!--    <div *ngIf="isCarryOver" class="pb-1 pl-1 date-and-time-2">-->
    <!--      <span class="mr-2">-->
    <!--        <span class="mr-2 opacity-70">Arrive: </span>-->
    <!--        <i class="fa fa-calendar"></i>-->
    <!--        {{ formatDateString(arriveHomeEarliest, arriveHomeLatest) }}-->
    <!--      </span>-->
    <!--    </div>-->
    <!--    <div *ngIf="isCarryOver" class="pb-1 pl-1 date-and-time">-->
    <!--      <span class="mr-2">-->
    <!--        <span class="mr-2 opacity-70">Leave: </span>-->
    <!--        <i class="fa fa-calendar"></i>-->
    <!--        {{ formatDateString(leaveHomeEarliest, leaveHomeLatest) }}-->
    <!--      </span>-->
    <!--    </div>-->
  </div>
</div>
